import { Box, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import GridCard from '../gridcard'
import brandsCard from '../../ui/brands-card.jpg';
import strategyCard from '../../ui/strategy-card.jpg';
import wellnessCard from '../../ui/wellness-card.jpg';
import leadershipCard from '../../ui/leadership-card.jpg';
import locationsCard from '../../ui/locations-card.jpg';
import corporateResponsibilityCard from '../../ui/corporate-responsibility-card.jpg';


export default function SimpleThreeColumns() {
  return (
    <Box p={4}>
      <VStack justify="center" marginBottom="20px">
        <Text fontSize={'4xl'} fontWeight={'bold'} align={'center'} fontFamily={'GerTT'}>A DIFFERENT KIND OF
          ADVENTURE</Text>
        <Text fontSize={'md'} align={'center'}>We’ve been creating innovative outdoor gear and technologies since 1938.
          It’s a good start.</Text>
      </VStack>
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={10}>
        <GridCard
          title="OUR BRANDS"
          backgroundImage={brandsCard}
          href="/careers/our-brands-group"
        />
        <GridCard
          title="STRATEGY, MISSION & VALUES"
          backgroundImage={strategyCard}
          href="/our-company/strategy-mission-values"
        />
        <GridCard
          title="WELLBEING & BENEFITS"
          backgroundImage={wellnessCard}
          href="/our-company/wellbeing-benefits"
        />
        <GridCard
          title="LEADERSHIP TEAM"
          backgroundImage={leadershipCard}
          href="/our-company/leadership"
        />
        <GridCard
          title="REGIONS & LOCATIONS"
          backgroundImage={locationsCard}
          href="/careers/regions-group/?tab-c40defabe206bb77568"
        />
        <GridCard
          title="CORPORATE RESPONSIBILITY"
          backgroundImage={corporateResponsibilityCard}
          href="corporate-responsibility-group"
        />
      </SimpleGrid>
    </Box>
  );
}
